import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BuscarCasos } from '../../app/model/pld/buscarcaso.model';
import { Observable } from 'rxjs';
import { TransaccionesCaso } from '../../app/model/pld/transaccionescaso.model';
import { EvidenciaCaso } from '../../app/model/pld/evidenciacaso.model';
import { DictamenCaso } from '../../app/model/pld/dictamencaso.model';
import { CoincidenciaCaso } from '../../app/model/pld/coincidencias.model';
import { CargaEvidencias } from '../../app/model/pld/cargaevidencia.model';
import { DetalleCaso, ModelCaso } from 'src/app/model/pld/detallecaso.model';

@Injectable({
	providedIn: 'root',
})
export class AlertasService {
	persona: any;
	buscando = false;
	transaccionesRelacionar: any[] = [];
	transaccionesResultados = [];
	casosResultados = [];
	caso: ModelCaso = new ModelCaso();

	endpoint = environment.apiUrl + 'PLD/administracioncasos/';
	endpointReporte = environment.apiUrl + 'Reportes/pld/';

	// endpoint = 'https://localhost:56196/' + 'administracioncasos/'; //aqui A208
	//endpointReporte = 'http://localhost:53210/' + 'pld/';

	constructor(private http: HttpClient) { }

	buscarCasos(values: BuscarCasos): Observable<any> {
		//return this.http.post<any>(this.endpoint + 'buscar', JSON.stringify(values));
    return this.http.post<any>(
      this.endpoint + 'buscarCasos',
      JSON.stringify(values)
    );
	}

	buscarCasosConteos(values: BuscarCasos): Observable<any> {
		return this.http.post<any>(
		this.endpoint + 'obtenerTotalCasos',
		JSON.stringify(values)
		);
	}

	buscarCasosBuzon(values: BuscarCasos): Observable<any> {
		return this.http.post<any>(this.endpoint + 'buscarBuzon', JSON.stringify(values));
	}

	obtenerPreocupante(casoId: number): Observable<any> {
		return this.http.get<any>(this.endpoint + 'obtenerpreocupante/' + casoId);
	}

	obtenerInusualBuzon(casoId: number): Observable<any> {
		return this.http.get<any>(this.endpoint + 'ObtieneInusualBuzon/' + casoId);
	}

	obtenercampo40inusuales(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo40inusuales', JSON.stringify(values));
	}

	obtenerdivisionesreporte(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenerdivisionesreporte', JSON.stringify(values));
	}

	obtenercampo41inusuales(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo41inusuales', JSON.stringify(values));
	}

	obtenercampo40InternasPreocupantes(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo40InternaPreocupante', JSON.stringify(values));
	}

	obtenercampo41InternasPreocupantes(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo41InternaPreocupante', JSON.stringify(values));
	}

	obtenerdivisionesreporteCampo41(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'ObtenerDivisionesReporteCampo41', JSON.stringify(values));
	}

	obtenercampo40EOperativaTmp(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo40EOperativaTmp', JSON.stringify(values));
	}

	obtenercampo40EOperativa(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo40EOperativa', JSON.stringify(values));
	}

	obtenercampo41EOperativa(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo41EOperativa', JSON.stringify(values));
	}

	obtenercampo40Tentativa(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo40Tentativa', JSON.stringify(values));
	}

	obtenercampo41Tentativa(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo41Tentativa', JSON.stringify(values));
	}

	obtenerRolIdAtiendeCasos() {
		return environment.rolAtiendeCasosId;
	}

	imprimirCasos(values: BuscarCasos): Observable<any> {
		let result = this.http.post<any>(this.endpointReporte + 'casos', JSON.stringify(values));
		return result;
	}

	buscarTransaccionesCaso(values: TransaccionesCaso): Observable<any> {
		let result = this.http.post<any>(this.endpoint + 'buscartransacciones', JSON.stringify(values));
		return result;
	}

	buscarCasoListas(values: EvidenciaCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'buscarcasoslistas', JSON.stringify(values));
	}

	buscarEvidenciaCaso(values: EvidenciaCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'buscardetalle', JSON.stringify(values));
	}

	buscarDictamenCaso(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'buscardictamen', JSON.stringify(values));
	}

	buscarCoincidencias(values: CoincidenciaCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'buscarcoincidencias', JSON.stringify(values));
	}

	guardarDictamenManual(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'dictamencasomanual', JSON.stringify(values));
	}

	guardarComiteManual(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'comiteManual', JSON.stringify(values));
	}

	//#region Campos 35 y 36
	obtenercampo40inusualesTmp(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo40inusualesTmp', JSON.stringify(values));
	}

	obtenercampo41inusualesTmp(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo41inusualesTmp', JSON.stringify(values));
	}

	obtenercampo40OperacionOperativaTmp(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo40OperacionOperativaTmp', JSON.stringify(values));
	}

	obtenercampo41OperacionOperativaTmp(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo41OperacionOperativaTmp', JSON.stringify(values));
	}

	obtenercampo40InternasPreocupantesTmp(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo40InternaPreocupanteTmp', JSON.stringify(values));
	}

	obtenercampo41InternasPreocupantesTmp(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo41InternaPreocupanteTmp', JSON.stringify(values));
	}

	obtenercampo41EOperativaTmp(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo41EOperativaTmp', JSON.stringify(values));
	}

	obtenercampo40TentativaTmp(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo40TentativaTmp', JSON.stringify(values));
	}

	obtenercampo41TentativaTmp(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'obtenercampo41TentativaTmp', JSON.stringify(values));
	}
	//#endregion Campos 35 y 36

	guardarEvidencia(values: CargaEvidencias): Observable<any> {
		return this.http.post<any>(this.endpoint + 'evidencia', JSON.stringify(values));
	}

	guardarComite(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'comite', JSON.stringify(values));
	}

	guardarCumplimiento(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'cumplimiento', JSON.stringify(values));
	}

	guardarDictamen(values: DictamenCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'dictamen', JSON.stringify(values));
	}

	guardarCaso(values: DetalleCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'caso', JSON.stringify(values));
	}

	descargarEvidencia(values: CargaEvidencias): Observable<any> {
		return this.http.post<any>(this.endpoint + 'descargarevidencia', JSON.stringify(values));
	}

	AsignarAtenderCaso(values: any): Observable<any> {
		return this.http.post<any>(this.endpoint + 'atender', JSON.stringify(values));
	}

	crearCasoTemporal(values: ModelCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'CrearNuevoCaso', JSON.stringify(values));
	}

	guardarTipoReporte(values: ModelCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'guardarTipoReporte', JSON.stringify(values));
	}

	guardarAlertaTipoReportar(values: ModelCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'guardaralertatiporeportar', JSON.stringify(values));
	}

	guardarMotivoReporte(values: ModelCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'guardarmotivoreporte', JSON.stringify(values));
	}

	buscarTransaccionesCasTMP(values: TransaccionesCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'buscartransaccionestmp', JSON.stringify(values));
	}

	buscarEvidenciaCasoTMP(values: EvidenciaCaso): Observable<any> {
		let result = this.http.post<any>(this.endpoint + 'buscardetalletmp', JSON.stringify(values));
		return result;
	}

	guardarEvidenciatmp(values: CargaEvidencias): Observable<any> {
		return this.http.post<any>(this.endpoint + 'evidenciatmp', JSON.stringify(values));
	}

	descargarEvidenciaTMP(values: CargaEvidencias): Observable<any> {
		return this.http.post<any>(this.endpoint + 'descargarevidenciatmp', JSON.stringify(values));
	}

	buscarCoincidenciasTmpCaso(values: CoincidenciaCaso): Observable<any> {
		return this.http.post<any>(this.endpoint + 'buscarcoincidenciastmp', JSON.stringify(values));
	}
}
